import { GetCycleSummaryResponse } from '../api-services/get-cycle-summary.service';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { ExecutePrintCompanyDataThumbnailService } from 'src/app/kymw/kymw23/kymw2300/api-services/execute-print-company-data-thumbnail.service';

/**
 * サイクル設定画面の予実情報クラス
 *
 * @export SummaryInfo
 * @class SummaryInfo
 */
export class SummaryInfo {
  /** 表示値 小数桁 */
  private static readonly DECIMAL_DEGITS = 2;

  orderCode: string;
  catalogId: string;
  budget: number;
  plan: number;
  result: number;
  prevResult: number;
  planDiff: number;

  // 予実表 切替値 0|1|2|3|4|5
  switchType: string = '0';

  constructor(data: GetCycleSummaryResponse[number]) {
    this.orderCode = data.OrderCode;
    this.catalogId = data.CatalogId;
    this.budget = Number(data.Budget);
    if (Number.isNaN(this.budget)) this.budget = 0;
    this.plan = Number(data.Plan);
    if (Number.isNaN(this.plan)) this.plan = 0;
    this.result = Number(data.Result);
    if (Number.isNaN(this.result)) this.result = 0;
    this.prevResult = Number(data.PrevResult);
    if (Number.isNaN(this.prevResult)) this.prevResult = 0;
  }

  /** 計画数 (計算後) */
  get calcPlan() {
    if (this.planDiff) return this.plan + this.planDiff;
    return this.plan;
  }

  /** 表示用 予算 */
  get dspBudget() {
    return PlessViewUtilsSub.editPriceComma(this.budget, true);
  }

  /** 表示用 計画 */
  get dspPlan() {
    return PlessViewUtilsSub.editPriceComma(this.calcPlan, true);
  }

  /** 表示用 実績 */
  get dspResult() {
    return PlessViewUtilsSub.editPriceComma(this.result, true);
  }

  /** 表示用 前年実績 */
  get dspPrevResult() {
    return PlessViewUtilsSub.editPriceComma(this.prevResult, true);
  }

  /** 切替値 */
  get switchValue() {
    if ('0' === this.switchType) {
      if (this.budget === 0) return '0%';
      return PlessViewUtilsSub.editPercent(
        Math.ceil(
          (this.calcPlan / this.budget) * 100 * 10 ** SummaryInfo.DECIMAL_DEGITS
        ) /
          10 ** SummaryInfo.DECIMAL_DEGITS
      );
    }
    if ('1' === this.switchType) {
      if (this.budget === 0) return '0%';
      return PlessViewUtilsSub.editPercent(
        Math.ceil(
          (this.result / this.budget) * 100 * 10 ** SummaryInfo.DECIMAL_DEGITS
        ) /
          10 ** SummaryInfo.DECIMAL_DEGITS
      );
    }
    if ('2' === this.switchType) {
      if (this.prevResult === 0) return '0%';
      return PlessViewUtilsSub.editPercent(
        Math.ceil(
          (this.budget / this.prevResult) *
            100 *
            10 ** SummaryInfo.DECIMAL_DEGITS
        ) /
          10 ** SummaryInfo.DECIMAL_DEGITS
      );
    }
    if ('3' === this.switchType && this.calcPlan) {
      return PlessViewUtilsSub.editPercent(
        Math.ceil(
          (this.result / this.calcPlan) * 100 * 10 ** SummaryInfo.DECIMAL_DEGITS
        ) /
          10 ** SummaryInfo.DECIMAL_DEGITS
      );
    }
    if ('4' === this.switchType) {
      if (this.prevResult === 0) return '0%';
      return PlessViewUtilsSub.editPercent(
        Math.ceil(
          (this.calcPlan / this.prevResult) *
            100 *
            10 ** SummaryInfo.DECIMAL_DEGITS
        ) /
          10 ** SummaryInfo.DECIMAL_DEGITS
      );
    }
    if ('5' === this.switchType) {
      if (this.prevResult === 0) return '0%';
      return PlessViewUtilsSub.editPercent(
        Math.ceil(
          (this.result / this.prevResult) *
            100 *
            10 ** SummaryInfo.DECIMAL_DEGITS
        ) /
          10 ** SummaryInfo.DECIMAL_DEGITS
      );
    }
    return '';
  }
}
